import { render, staticRenderFns } from "./DialogLoginAndRegister.vue?vue&type=template&id=0d74d3e9&scoped=true&"
import script from "./DialogLoginAndRegister.vue?vue&type=script&lang=js&"
export * from "./DialogLoginAndRegister.vue?vue&type=script&lang=js&"
import style1 from "./DialogLoginAndRegister.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74d3e9",
  null
  
)

export default component.exports